"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _excluded = ["active", "sortDirection"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SortIndicator = function SortIndicator(_ref) {
  var active = _ref.active,
      sortDirection = _ref.sortDirection,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: !active || sortDirection === _reactVirtualized.SortDirection.DESC ? 'table.sortAsc' : 'table.sortDesc'
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement("span", _extends({
      title: title
    }, props), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 10",
      width: "10",
      height: "10"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      className: active && sortDirection === _reactVirtualized.SortDirection.DESC ? 'active' : '',
      d: "M7.8.61v7.3L8.94,6.79a.63.63,0,0,1,.88,0,.6.6,0,0,1,0,.86L7.62,9.82a.63.63,0,0,1-.88,0L4.54,7.65a.59.59,0,0,1,0-.86.63.63,0,0,1,.88,0L6.56,7.91V.61A.61.61,0,0,1,7.18,0,.61.61,0,0,1,7.8.61Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      className: active && sortDirection === _reactVirtualized.SortDirection.ASC ? 'active' : '',
      d: "M2.2,9.39V2.09L1.06,3.21a.63.63,0,0,1-.88,0,.6.6,0,0,1,0-.86L2.38.18a.63.63,0,0,1,.88,0l2.2,2.17a.59.59,0,0,1,0,.86.63.63,0,0,1-.88,0L3.44,2.09v7.3a.61.61,0,0,1-.62.61A.61.61,0,0,1,2.2,9.39Z"
    })));
  });
};

SortIndicator.propTypes = {
  active: _propTypes["default"].bool,
  sortDirection: _propTypes["default"].oneOf([_reactVirtualized.SortDirection.ASC, _reactVirtualized.SortDirection.DESC])
};
SortIndicator.defaultProps = {
  active: false,
  sortDirection: _reactVirtualized.SortDirection.DESC
};
var _default = SortIndicator;
exports["default"] = _default;